import React from "react";
import { Section, Wrapper, SectionHead } from "../SectionHead";
import {
  Grid,
  Copy,
  Paragraph,
  FocusChips,
  Chip,
  FactList,
  Fact,
  FactLabel,
  FactValue,
  StatGrid,
  StatCard,
  StatValue,
  StatLabel,
} from "./AboutStyle";
import { fadeUp, viewportOnce } from "../../utils/motion";
import { Bio, stats } from "../../data/constants";
import { useCountUp } from "../../hooks/useCountUp";

const FOCUS_AREAS = [
  "System Architecture",
  "Cloud Infrastructure",
  "AI / ML Integration",
  "DevOps & CI/CD",
  "IT Governance",
  "Engineering Mentorship",
];

const formatValue = (value, suffix) => {
  if (value >= 1000) {
    return `${Math.round(value / 100) / 10}k${suffix}`;
  }
  return `${Math.round(value)}${suffix}`;
};

const StatItem = ({ stat, index }) => {
  const { ref, value } = useCountUp(stat.value, { duration: 1.4 + index * 0.1 });
  return (
    <StatCard
      ref={ref}
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      custom={index}
    >
      <StatValue>{formatValue(value, stat.suffix)}</StatValue>
      <StatLabel>{stat.label}</StatLabel>
    </StatCard>
  );
};

const About = () => {
  return (
    <Section id="about" style={{ scrollMarginTop: 96 }}>
      <Wrapper>
        <SectionHead
          eyebrow="About Me"
          title="I've spent the last 7 years building backend systems and the infrastructure they run on."
          subtitle="Here's what I focus on, plus a few numbers behind the work."
        />

        <Grid>
          <Copy variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportOnce} custom={1}>
            <Paragraph>{Bio.longDescription}</Paragraph>
            <Paragraph>
              I've shipped systems across fintech, healthtech, proptech, and legal tech,
              including a facilities management platform running on 27 sites, a biometric
              payroll and attendance system, and an ERP for a university. I care about the
              architecture as much as the infrastructure it runs on.
            </Paragraph>

            <FocusChips>
              {FOCUS_AREAS.map((area) => (
                <Chip key={area}>{area}</Chip>
              ))}
            </FocusChips>

            <FactList>
              <Fact>
                <FactLabel>Role</FactLabel>
                <FactValue>{Bio.title}</FactValue>
              </Fact>
              <Fact>
                <FactLabel>Location</FactLabel>
                <FactValue>{Bio.location}</FactValue>
              </Fact>
              <Fact>
                <FactLabel>Certifications</FactLabel>
                <FactValue>ITIL 4 &middot; Security+ &middot; CCNA</FactValue>
              </Fact>
              <Fact>
                <FactLabel>Email</FactLabel>
                <FactValue>{Bio.email}</FactValue>
              </Fact>
            </FactList>
          </Copy>

          <StatGrid as="div">
            {stats.map((stat, i) => (
              <StatItem key={stat.id} stat={stat} index={i} />
            ))}
          </StatGrid>
        </Grid>
      </Wrapper>
    </Section>
  );
};

export default About;
